import ModalCloseConfirm from "./ModalCloseConfirm";

export default ModalCloseConfirm;
